module.exports = __webpack_public_path__ + "static/3-c4e1eed960fff5e263b19966f13c32ba.jpg";